import { cn } from '@/lib/utils'

export function Table({ className, ...props }) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={cn('w-full text-sm border-collapse', className)} {...props} />
    </div>
  )
}

export function THead({ className, ...props }) {
  return <thead className={cn('text-left text-muted-foreground', className)} {...props} />
}

export function TH({ className, ...props }) {
  return <th className={cn('font-medium px-4 py-2.5 border-b border-border', className)} {...props} />
}

export function TBody(props) {
  return <tbody {...props} />
}

/** Linha com zebra + hover sutis (índice par/ímpar). */
export function TR({ className, index, clickable, ...props }) {
  return (
    <tr
      className={cn(
        index % 2 === 1 ? 'bg-muted/40' : 'bg-transparent',
        'hover:bg-accent/50 transition-colors',
        clickable && 'cursor-pointer',
        className
      )}
      {...props}
    />
  )
}

export function TD({ className, ...props }) {
  return <td className={cn('px-4 py-2.5 border-b border-border/60', className)} {...props} />
}
